import React, { memo } from 'react';
import { AccessoriesCard } from '@yme/molecules/cards';
import { buildKey } from '@yme/utils/common';
import { getProductCardData } from '@yme/utils/product';
import { ProductCardStyled } from '../FilterResults/styled';
import { useProductsBeforeEmbargoRelease } from './useProductsBeforeEmbargoRelease';
function ResultsBeforeEmbargoReleaseComponent({ categoryIds, productEndpoint, productType, pdpPageUrl, daysToShowNew, isRightToLeft, rootLanguage, updateItemsRef, }) {
    const { productsBeforeEmbargoRelease } = useProductsBeforeEmbargoRelease({
        categoryIds,
        productEndpoint,
        productType,
    });
    return (React.createElement(React.Fragment, null, productsBeforeEmbargoRelease.map((item, index) => {
        const id = item?.id || item?.slug || '';
        const key = buildKey(id, index);
        if (!item || !item?.variants) {
            return null;
        }
        const { name, isStock, images, embargoExternal, popularityIndex, prices, cardUrl, isLabelFromVisible, } = getProductCardData({
            itemData: item,
            path: pdpPageUrl,
            isInAuthor: true,
            isImageMasterVariant: false,
            isCheapestVariant: true,
        });
        const cardProps = {
            name,
            prices,
            images,
            embargoExternal,
            popularityIndex,
            isStock,
            cardUrl,
            daysToShowNew,
            isLabelFromVisible,
        };
        return (React.createElement(ProductCardStyled, { key: key, id: id, ref: (el) => {
                if (el) {
                    updateItemsRef?.(id, {
                        current: el,
                    });
                }
            } },
            React.createElement(AccessoriesCard, { isRightToLeft: isRightToLeft, cardProps: cardProps, language: rootLanguage })));
    })));
}
export const ResultsBeforeEmbargoRelease = memo(ResultsBeforeEmbargoReleaseComponent);
